/* Import Libs */

import PhoneMask from './js/inputmask';
import Counter from './js/counter';
import LazyLoad from "vanilla-lazyload";
import './js/validation';
import './js/utils';
import './js/preloader';
import '../../node_modules/focus-visible/dist/focus-visible';
import './js/waiting';
import './js/key';
import './js/filter';
import './js/filter-modal';
import './js/modal';
import './js/cart';
import Otp from './js/otp';
import './js/menu';
import './js/verbose';
import './js/dropzone';

/* * Header * */
// import './partials/header/userbar/userbar';
import './partials/header/header-call';
import './partials/header/header-phones';
import './partials/header/header-menu';

/* * Drawer * */
import './partials/header/drawer-nav/drawer-nav';
import './partials/header/search/search';
// import './partials/product/wish-list/wish-list';

/* * Form * */
import './partials/form/input/input';
import './partials/form/input/textarea';

/* * Other * */
// import './partials/product/cart/cart-product/cart-product';

// import './partials/product/wish-list/wish-product/wish-product';
import './partials/common/wysiwyg/wysiwyg';
import './partials/common/evermodal/evermodal-dialog';

import './partials/common/account/account';
// import './partials/common/buy/add-to-cart';
import './partials/common/buy/buy-drawer';
// import './partials/common/buy/buy-counter';
// import './partials/product/product-buy/button-block';

import './partials/common/pagination/showmore';
import './partials/content/products-sample/products-sample';
import './pages/account';
// import './partials/content/crud-items/crud-items';

$(window).scroll(() => {
  const scroll = $(window).scrollTop();

  if (scroll >= 60) {
    $('body').addClass('fixed-nav');
  } else {
    $('body').removeClass('fixed-nav');
  }
});

document.addEventListener('ajax:success', (e) => {

  PhoneMask.init();
  Otp.init();
  Counter.init();

  if(typeof e.detail.message === 'undefined') {
      document.dispatchEvent(new CustomEvent("dialog-close", {bubbles: true}));
  } else {
      document.dispatchEvent(new CustomEvent("dialog-wait", {
          detail: {
            message: e.detail.message,
            status: e.detail.status
          }
      }));
  }
});

window.callbackResponse = (e) => {

  if(null !== e.data && e.data === 'onConsult') {
    dataLayer.push({ event: "form_sent"});
  }
  
  document.dispatchEvent(new CustomEvent("ajax:success", {
      detail: {
          status: e.status, 
          message: e.message
      }
  }));
} 

let showPropsClick = () => {
  document.addEventListener('click', (el) => {
    if(!el.target.matches(`._show-props-click`)) return;
    const containerProps = el.target.closest(`._container-props`);
    containerProps.classList.toggle('active');
  });
}

let accordeonDropdownClick = () => {
  document.addEventListener('click', (el) => {
    if(!el.target.matches(`._dropdown-click`)) return;
    el.target.classList.toggle('active');
  });
}

let showCatalogClick = () => {
  document.addEventListener('click', (el) => {
    if(!el.target.matches(`._open-block`)) return;
    el.target.nextSibling.classList.toggle('active');
  });
}

let isTouchDevice = () => {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

let keyable = () => {
  addEventListener('ajax:setup', function(e) {
    let { context } = e.detail;

    let form;
    if(context.el == document) {
        form = context.el.querySelector('._keyable');

        if(form == null) return;

    } else {
        if(!context.el.classList.contains(`_keyable`)) return;

        form = context.el;
    }

    if(typeof form.elements._key == 'undefined') {
      var KEY = document.createElement("input");
      KEY.setAttribute("type", "hidden");
      KEY.setAttribute("name", "_key");
      KEY.setAttribute("value", "");
  
      form.appendChild(KEY);
    }

    for (var i = 0; i < form.childNodes.length; i++) {
        if(form.childNodes[i].name == '_key') {
            form.childNodes[i].value = Key.get();
        }
    }
  });
}

let accordeonDropdownMouseenter = () => {

  // is touch device
  if(isTouchDevice()) {

    document.addEventListener('click', (el) => {

      if(!el.target.matches(`._dropdown-mouseenter`)) return;

      console.log( el.target.classList.contains('active') );

      if(!el.target.classList.contains('active')) {
        const items = getAllSiblings(el.target, `._dropdown-mouseenter`);
        [...items].forEach(el => el.classList.remove('active'));
      }

      el.target.classList.toggle('active');

    });

  } else {

    const selectors = document.querySelectorAll(`._dropdown-mouseenter`);

    [...selectors].forEach(selector => {
  
        selector.addEventListener('mouseenter', (el) => {
          el.target.classList.add('active');
        });
      
        selector.addEventListener('mouseleave', (el) => {
          el.target.classList.remove('active');
        });
  
    });

  }
}

const initialize = () => {

  addEventListener('ajax:invalid-field', function(event) {
    let { element, fieldName, errorMsg, isFirst } = event.detail;
    if(element.type == 'select-one') {
      element = element.parentNode;
    }

    element.classList.add('is-invalid');
  });

  addEventListener('ajax:promise', function(event) {

      if(event.target == document) return;

      const form = event.target.closest('form');
      
      if(form == null) return;

      form.querySelectorAll('.is-invalid').forEach(function(el) {
          el.classList.remove('is-invalid');
      });
  });

  document.addEventListener('keydown', (event) => {
    const e = event || window.event;
    if ((e.which || e.keyCode) === 13) {
      const elem = document.querySelector('.bind_enter');
      const eventClick = new Event('click');
      elem.dispatchEvent(eventClick);
    }
  });

  addEventListener('ajax:promise', (event) => {
      let { el } = event.detail.context;

      if(el != document) {
          //document.dispatchEvent(new CustomEvent("dialog-wait", {bubbles: true}));
      }
  });

  Counter.init();

  document.addEventListener('click', (el) => {
      if (el.target.matches(`.dropdown__item-title`)) {
          const item = el.target.parentNode;
      
          const items = getAllSiblings(item, `.dropdown__item`);
          [...items].forEach(el => el.classList.remove('active'));
    
          el.target.parentNode.classList.toggle('active');
      }

      if(el.target.matches(`.single__order-item_caption`)) {
          el.target.parentNode.classList.toggle('active');
      }
  });

  accordeonDropdownClick();
  accordeonDropdownMouseenter();
  showCatalogClick();
  showPropsClick();
  keyable();

  new LazyLoad();
}

function getAllSiblings(element, className) {
  const parent = element.parentNode;
  const children = [...parent.children];
  return children.filter(child => 
    child.matches(className) && child !== element
  );
}

window.scrollTo = (element, offset = 30) => {

  const elementSelector = document.querySelector(`${element}`); 

  if(null == elementSelector) return;
  
  const offsetTop = Math.round(elementSelector.parentNode.getBoundingClientRect().top + document.documentElement.scrollTop - offset);

  window.scroll({
    top: offsetTop, 
    left: 0, 
    behavior: 'smooth' 
  });
}

addEventListener('page:loaded', () => initialize());
